import { Button, Stack, Typography } from '@mui/material'
import { useTranslate } from '@tolgee/react'
import { MRT_Row, MRT_RowData, MRT_TableInstance } from 'material-react-table'
import { useMinimalsTheme } from '../../../../hooks'
import { ButtonWithDropdown } from '../../button/ButtonWithDropdown'

export type TomTableActionsProps<TData extends MRT_RowData> = {
  label: string
  grouped?: boolean
  disabled?: boolean
  onClick: (rows: MRT_Row<TData>[]) => void
  testId?: string
}

export const TomTableActions = <TData extends MRT_RowData>(props: {
  table: MRT_TableInstance<TData>
  tableActions: TomTableActionsProps<TData>[]
}) => {
  const { table, tableActions } = props
  const { t } = useTranslate()
  const theme = useMinimalsTheme()

  const groupedActions = tableActions.filter(action => action.grouped)
  const hasGroupedActions = groupedActions.length > 0

  const ungroupedActions = tableActions.filter(action => !action.grouped)

  return (
    <Stack direction='row' gap={theme.customSpacing.s} alignItems='center'>
      {ungroupedActions.map(action => {
        return (
          <Button
            key={action.label}
            variant='text'
            color='inherit'
            onClick={() => {
              const rows = table.getSelectedRowModel().rows
              action.onClick(rows)
            }}
          >
            <Typography variant='subtitle2' color='textPrimary'>
              {action.label}
            </Typography>
          </Button>
        )
      })}

      {hasGroupedActions && (
        <ButtonWithDropdown
          label={t('moreActions', 'More actions')}
          size='small'
          color='inherit'
          variant='text'
          testId='more-actions-btn'
          options={groupedActions.map(action => {
            return {
              disabled: action.disabled,
              label: action.label,
              onClick: () => {
                const rows = table.getSelectedRowModel().rows
                action.onClick(rows)
              },
              testId: action.testId,
            }
          })}
        />
      )}
    </Stack>
  )
}
